import { render, staticRenderFns } from "./DocCode.vue?vue&type=template&id=7deeb79c&scoped=true&"
import script from "./DocCode.vue?vue&type=script&lang=js&"
export * from "./DocCode.vue?vue&type=script&lang=js&"
import style0 from "./DocCode.vue?vue&type=style&index=0&id=7deeb79c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7deeb79c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VIcon,VTab,VTabs})
